// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b2f1d673","162":"67c25ec9","359":"a36c11c7","384":"b6e6c3e7","496":"8fc59192","772":"2ba1cbd8","919":"bd1385c4"}[chunkId] + ".chunk.js";
};